// extracted by mini-css-extract-plugin
export var falconContainer = "_v9-2";
export var offerCenter = "_v9-0";
export var roktContainer = "_v9-1";